import { createRouter } from '@halo/wallet-app';

export const router = createRouter({ creatorType: 'memory' });
